//REGISTER
export const TOKEN_KEY = "token";
export const LOBBY_KEY = "lobby-type";
export const LOBBY_MOB_PERM = "lobby_mob_type";
export const LOBBY_WEB_PERM = "lobby_web_type";
export const LOBBY_VERSION_KEY = "lobby_app_version";
export const API_PREFIX = "";
export const APPLICATION_EXT = "/user-api";
export const CARD_GANE_MS_EXT = "/card-game";
export const TOGEL_MS_EXT = "/lottery-api";
export const MASTER_MS_EXT = "/master";
export const ADMIN_MS_EXT = "/admin";
export const PLAYER_MS_EXT = "/player-api";

export const CARD_GAME_API = {
    lauchGame: "/launchGame",
};
export const TOGEL_API = {
    process4D3D2D: "/process4D3D2D",
    listGame: "/listGame",
    getResultTogel: "/getResultTogel",
    getResultTogelNew: "/getResultTogelNew",
    listResultInformation: "/listResultInformation",
    loadProcess4D3D2DTGData: "/loadProcess4D3D2DTGData",
    processBBCampuran: "/processBBCampuran",
    processDataBet: "/processDataBet",
    processBolakBalik:"/processBolakBalik",
    generateQuickBet: "/generateQuickBet",
    processQuickBuy: "/processQuickBuy",
    getTogelGame: "/getTogelGame",
    processAltTogel: "/processAltTogel",
    process5050Shio : "/process5050Shio",
    processPolaTarung: "/processPolaTarung",
    getTogelDetails: "/getTogelDetails",
    listInvoiceTogelData: "/listInvoiceTogelData",
    getInvoiceTogel: "/getInvoiceTogel",
    marketDD: "/marketDD",
    getResultInformation: "/getResultInformation",
    marketOpenClosedTime: "/marketOpenClosedTime",
    getAllPrizeDiscount: "/getAllPrizeDiscount",
    getSubGameStatus: "/getSubGameStatus",
    getGamePeriod: "/getGamePeriod",
    getGameStatus: "/getGameStatus",
    processBolakBalik5D6D: "/processBolakBalik5D6D",
    process5D6D: "/process5D6D"
};

export const EXCLUDE_LOADER = [
    "/getUserBalance",
    "/updateAvatar",
    "/checkNickname",
    "/keepUserActive",
    "/checkSession",
    "/getUserEventBonusCoin",
    "/updateUserTheme",
    "/getUser",
    "/checkDevice",
    "/getPromoBanner"
];

export const PLAYER_API = {
    updateUserLanguage: "/updateUserLanguage",
    addUserSession: "/addUserSession",
    getUser: "/getUser",
    getUserBalance: "/getUserBalance",
    listNotification: "/listNotification",
    getNotification: "/getNotification",
    listTransaction: "/listTransaction",
    getTransaction: "/getTransaction",
    listEventBonus: "/listEventBonus",
    listTurnover: "/listTurnover",
    getTurnover: "/getTurnover",
    getHistoryDetail: "/getHistoryDetail",
    listReferral: "/listReferral",
    listReferralBonus: "/listReferralBonus",
    getReferralBonus: "/getReferralBonus",
    generateNickname: "/generateNickname",
    checkNickname: "/checkNickname",
    updateNickname: "/updateNickname",
    updateAvatar: "/updateAvatar",
    logout: "/logout",
    getFtpUrl: "/getFtpUrl",
    getAvatar: "/getAvatar",
    getCoinReward: "/getCoinReward",
    keepUserActive:"/keepUserActive",
    checkSession: "/checkSession",
    getUserEventBonusCoin : "/getUserEventBonusCoin",
    updateUserTheme: "/updateUserTheme",
    checkDevice: "/checkDevice",
    getCoachDetails:"/getCoachDetails",
    updateCoachMarkStatus:"/updateCoachMarkStatus",
    getPromoBanner:"/getPromoBanner",
    fetchLoader: "/fetchLoader",
    verifyLogin: "/verifyLogin",
    redirectLobby: "/redirectLobby",
}
